/**
 * @file Manages the init storage in local storage
 */

export type Init = {
  isFirstLoginSignup: boolean;
};

/**
 * Get the current Init
 */
export function get(): Init | null {
  const init = window.localStorage.getItem('init');

  if (init) {
    return JSON.parse(init);
  }

  return null;
}

/**
 * Set the Init
 *
 * @param init
 */
export function set(init: Init) {
  window.localStorage.setItem('init', JSON.stringify(init));
}

/**
 * Remove the init
 */
export function remove() {
  window.localStorage.removeItem('init');
}
